import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startCheckout = async (lookupKey, { userId = null, listingId = null, quantity = 1 } = {}) => {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: lookupKey,
    quantity,
    origin_url: window.location.origin,
    user_id: userId,
    listing_id: listingId,
  });
  if (data?.checkout_url) {
    window.location.href = data.checkout_url;
  } else {
    throw new Error('Checkout URL missing');
  }
};

export const LOOKUP_KEYS = {
  boost: 'kushe_boost_single',
  pro: 'kushe_pro_monthly',
  business: 'kushe_business_monthly',
};
